const wrapperCls = "_vcw1lnw4ee";
const durationCls = "_vcd3bc1pc";
const currentDurationCls = "_vccb8tjtp";
const totalDurationCls = "_vct1sflixc";
const playButtonCls = "_vcphslegd";
const metaCls = "_vcmkz1p3l";
const metaTitleCls = "_vcm1aht3gj";
const metaDescriptionCls = "_vcm1uf8396";
const svgCls = "_vcsnr4o93";

export { currentDurationCls, durationCls, metaCls, metaDescriptionCls, metaTitleCls, playButtonCls, svgCls, totalDurationCls, wrapperCls };
import "./audio-component.scrambled.style.linaria.module.css";
//# sourceMappingURL=audio-component.scrambled.style.js.map
